import type { Questionnaire, QuestionnaireItem, QuestionnaireResponse, QuestionnaireResponseItem } from "fhir/r3"
import type { SimplifiedAppointment } from "../appointment.types"
import { enableWhenConditionsMet } from "../components/question/enableWhenConditionsMet"

export async function submitQuestionnaireResponse(
  healthcareServiceId: string,
  appointment: SimplifiedAppointment,
  questionnaire: Questionnaire,
  answers: QuestionnaireResponseItem[],
  token?: string | null,
): Promise<void> {
  const questionnaireResponseBody: QuestionnaireResponse = {
    meta: questionnaire.meta,
    resourceType: "QuestionnaireResponse",
    status: "completed",
    questionnaire: {
      reference: `${questionnaire.resourceType}/${questionnaire.id ?? ""}`,
      display: questionnaire.title,
    },
    subject: {
      reference: `Appointment/${appointment.id ?? ""}`,
    },
    author: appointment.participantPatientReference[0],
    item: mapQuestionsToAnswers(questionnaire.item ?? [], answers),
  }

  const response = await fetch(
    `/api/healthcareservice/${healthcareServiceId}/questionnaire/${questionnaire.id ?? ""}/response`,
    {
      method: "POST",
      body: JSON.stringify(questionnaireResponseBody),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  )

  // Return the QuestionnaireResponse once implemented.
  if (response.ok) {
    return
  }
  throw Error("questionnaire submit failed")
}

function mapQuestionsToAnswers(
  questions: QuestionnaireItem[],
  answers: QuestionnaireResponseItem[],
): QuestionnaireResponseItem[] {
  return questions.map((question) => {
    const isUsedQuestion = question.enableWhen == null || enableWhenConditionsMet(question.enableWhen, answers)
    const answer = isUsedQuestion
      ? answers.find((possibleAnswer) => possibleAnswer.linkId === question.linkId)
      : undefined

    const { linkId, definition, text } = question

    if (question.type === "group") {
      return {
        linkId,
        definition,
        text,
        item: mapQuestionsToAnswers(question.item ?? [], answers),
      }
    }

    return {
      linkId,
      definition,
      text,
      ...answer,
    }
  })
}
